import React from 'react'

const stopEventBubble = (e) => {
  e.stopPropagation();
};

const EditModal = ({ closeModal, confirmAction, title, content, style }) => {
  return (
    <div
      className="modal-content"
      style={style}
      onClick={stopEventBubble}
      onMouseDown={stopEventBubble}
      onPointerDown={stopEventBubble}
    >
      <div className="modal-header">
        <h5
          className="modal-title"
        >{title}</h5>
        <button type="button" className="btn-close" aria-label="Close" onClick={closeModal}></button>
      </div>
      <>
        {content}
      </>
    </div>
  )
}

export default EditModal